import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../dataShare/data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent implements OnInit, OnDestroy {

  captcha: string = '';
  userInput: string = '';
  message: string = '';
  speechSynthesis: SpeechSynthesis;
  isVerified:boolean;
  // captchaFlag:boolean|null=null;
  // @ViewChild('captchaCanvas', { static: true }) captchaCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('captchaCanvas', ) captchaCanvas!: ElementRef<HTMLCanvasElement>;
  captchaVerificationSubscription: Subscription;
  constructor(
    private toaster:ToastrService,
    private captchaStatus:DataService
    ) {  }
  
  ngOnDestroy(): void {
    this.captchaVerificationSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.captchaStatus.newFlagonpageload = true;
    this.generateCaptcha();
    this.captchaStatus.newFlagonpageload = true;
    this.speechSynthesis = window.speechSynthesis ;
    setInterval(()=>{
      this.generateCaptcha();
  },3*60*1000)
  this.captchaStatus.regenerateCaptcha$.subscribe(() => {
    // Logic to regenerate your captcha
    this.generateCaptcha();
  });
  this.captchaVerificationSubscription = this.captchaStatus.verifyCaptcha$.subscribe(() => {
        this.verifyCaptcha();
    });
   }

  generateCaptcha() {
    // Clear the canvas
    const canvas = this.captchaCanvas.nativeElement;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
     // Set the background color
    ctx.fillStyle = '#ffffff'; // Replace with your desired background color
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    // Add noise to the CAPTCHA by drawing random lines and dots
    for (let i = 0; i < 70; i++) {
      ctx.strokeStyle = '#2F9688';
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    // Draw the CAPTCHA text
    ctx.font = '40px Arial';
    ctx.fillStyle = '#333';
    ctx.fillText(captcha, 90, 90);

    this.captcha = captcha;
  }


  verifyCaptcha() {
    // console.log(this.captchaStatus.newFlagonpageload,'flag', this.userInput)
    if(this.captchaStatus.newFlagonpageload === false && this.userInput == ''){
      this.toaster.error("Please enter captcha");
      // this.captchaStatus.newFlagonpageload = true;
      this.captchaStatus.captchaFlag=false;
    }
     if (this.userInput === this.captcha) {
      this.captchaStatus.captchaFlag=true;
      this.isVerified=true;
      this.message = 'Captcha matched!';
      // this.toaster.success("Captcha Verified Successfully")
    } else if(this.userInput !== ''){
      this.captchaStatus.captchaFlag=false;
      // this.captchaStatus.newFlagonpageload = true;
      this.isVerified=false;
      this.message = 'Captcha did not match. Please try again.';
      this.toaster.error(this.message)
      this.generateCaptcha(); // Regenerate a new CAPTCHA on failure
    } 
    this.userInput = ''; // Clear user input
    // if(this.captchaStatus.regenerateCaptcha==true){
    //   this.generateCaptcha();
    // }
  }

  speakCaptcha() {
    const utterance = new SpeechSynthesisUtterance(this.captcha);

    // Optionally, you can customize the speech settings
    utterance.lang = 'en-UK'; // Set the language
    utterance.rate = 0.5;    // Set the speech rate (1.0 is normal speed)

    this.speechSynthesis.speak(utterance);
  }
}

